import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GuildMarker from "../../tools/guildMarker";
import PanelFrame from "../../ui/PanelFrame";
import signIcon from "../../../assets/imgs/signs.png";
import "./csWinners.scss";

const CsWinners = () => {
  const csWinners = useSelector(
    (state) => state.reducerWeb.castleSiegeWinners.data
  );
  const csRegistered = useSelector(
    (state) => state.reducerWeb.castleRegisteredGuilds.data
  );

  return (
    <PanelFrame title="Castle Siege">
      <div className="containerCsWin">
        {csWinners && csWinners.length > 0 ? (
          csWinners.map((guild) => (
            <div
              key={guild.G_Name || guild.OWNER_GUILD}
              className="subContainerCsWin"
            >
              <div>
                <GuildMarker mark={guild?.G_Mark} size={80} />
              </div>
              <div className="containerContentCsWin">
                <div className="titleContentCsWin">Castle Owner</div>
                <Link
                  to={`/guild/${guild.G_Name || guild.OWNER_GUILD}`}
                  className="titleContentCsWin newCursor"
                >
                  {guild.G_Name || guild.OWNER_GUILD}
                </Link>
                <div className="titleContentCsWin">Guild Master</div>
                <Link
                  to={`/player/${guild.G_Master}`}
                  className="titleContentCsWin newCursor"
                >
                  {guild.G_Master}
                </Link>
              </div>
            </div>
          ))
        ) : (
          <div className="mu-empty-rows">No castle owner data</div>
        )}

        <div className="containerRegistered">
          <h3 className="registeredTitle">Registered This Week</h3>
          {!csRegistered || csRegistered.length === 0 ? (
            <div className="registeredEmpty">No guilds registered</div>
          ) : (
            <ul className="registeredList">
              {csRegistered.map((g) => (
                <li key={g.G_Name} className="registeredItem">
                  <div className="guildLeft">
                    <GuildMarker mark={g.G_Mark} size={40} />
                    <Link to={`/guild/${g.G_Name}`} className="guildName">
                      {g.G_Name}
                    </Link>
                  </div>
                  <div className="guildMarks">
                    <img src={signIcon} alt="" className="signIcon" />×
                    {g.REG_MARKS}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </PanelFrame>
  );
};

export default CsWinners;
